import reframe, { dispatch } from 'nike-re-framejs';

import { defaultMiddlewares } from '@/common/util';
import { getKey, setKey } from '@/services/localStorage';
import { loadUserSettings } from '@/account/handlers';

export function initUserSetting(db) {
    dispatch(loadUserSettings);
    return db.setIn(['account', 'userConfig', 'showDeposit'], getKey('nikeUserDeposit') || 'showed');
}

reframe.regEventDb('userDepositSetting', defaultMiddlewares, (db, [data]) => {
    setKey('nikeUserDeposit', data);
    return db.setIn(['account', 'userConfig', 'showDeposit'], data);
});
